import { render, staticRenderFns } from "./zone_config.vue?vue&type=template&id=29bc6a94&scoped=true"
import script from "./zone_config.vue?vue&type=script&lang=js"
export * from "./zone_config.vue?vue&type=script&lang=js"
import style0 from "./zone_config.vue?vue&type=style&index=0&id=29bc6a94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bc6a94",
  null
  
)

export default component.exports